import { getLogger } from '@signalwire/core';
export const watchRTCPeerMediaPackets = (rtcPeer) => {
    if (!rtcPeer.hasAudioReceiver && !rtcPeer.hasVideoReceiver) {
        getLogger().warn(`Missing receivers to inspect media for RTCPeer "${rtcPeer.uuid}"`);
        return;
    }
    getLogger().debug(`Start watching media for RTCPeer "${rtcPeer.uuid}"`);
    let previousAudioValue = 0;
    let previousVideoValue = 0;
    let run = true;
    let timer;
    const clearTimer = () => {
        clearTimeout(timer);
    };
    const meter = async () => {
        var _a, _b;
        let audioPacketsReceived = 0;
        let videoPacketsReceived = 0;
        try {
            const stats = await rtcPeer.instance.getStats(null);
            const audioTrackId = (_a = rtcPeer.remoteAudioTrack) === null || _a === void 0 ? void 0 : _a.id;
            const videoTrackId = (_b = rtcPeer.remoteVideoTrack) === null || _b === void 0 ? void 0 : _b.id;
            stats.forEach((report) => {
                if (report.type === 'inbound-rtp' &&
                    report.kind === 'audio' &&
                    report.trackIdentifier === audioTrackId) {
                    getLogger().trace(`audio inbound-rtp: packetsReceived: ${report.packetsReceived} (at ${report.lastPacketReceivedTimestamp})`);
                    audioPacketsReceived = report.packetsReceived;
                }
                if (report.type === 'inbound-rtp' &&
                    report.kind === 'video' &&
                    report.trackIdentifier === videoTrackId) {
                    getLogger().trace(`video inbound-rtp: packetsReceived: ${report.packetsReceived} (at ${report.lastPacketReceivedTimestamp})`);
                    videoPacketsReceived = report.packetsReceived;
                }
            });
        }
        catch (error) {
            getLogger().warn('getStats error', error);
        }
        finally {
            const noAudioChanged = audioPacketsReceived && audioPacketsReceived <= previousAudioValue;
            const noVideoChanged = videoPacketsReceived && videoPacketsReceived <= previousVideoValue;
            if (noAudioChanged && noVideoChanged) {
                getLogger().warn(`audioPacketsReceived: ${audioPacketsReceived} - previousAudioValue: ${previousAudioValue}`);
                getLogger().warn(`videoPacketsReceived: ${videoPacketsReceived} - previousVideoValue: ${previousVideoValue}`);
                rtcPeer.triggerResume();
            }
            else {
                previousAudioValue = audioPacketsReceived !== null && audioPacketsReceived !== void 0 ? audioPacketsReceived : previousAudioValue;
                previousVideoValue = videoPacketsReceived !== null && videoPacketsReceived !== void 0 ? videoPacketsReceived : previousVideoValue;
                clearTimer();
                if (run && rtcPeer.instance.connectionState !== 'closed') {
                    timer = setTimeout(() => meter(), rtcPeer.watchMediaPacketsTimeout);
                }
            }
        }
    };
    return {
        start: () => {
            clearTimer();
            meter();
        },
        stop: () => {
            run = false;
            clearTimer();
        },
    };
};
//# sourceMappingURL=watchRTCPeerMediaPackets.js.map